import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {getOrderStatus} from "./I miei Ordini";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {DynamicEditComponent} from "../../../app/shared/dynamic-edit/dynamic-edit.component";
import {SecurityContext} from "@angular/core";
import {ImageUrl, PrezzoIvato} from "./ProductUtility";
import {dateTimeStringToFormattedDate, DateToString} from "../../Utility/DateUtility";
import {environment} from "../../BaseEnvironments/EmmeEvolution_Marketplace";

const oreScadenzaOrdine = environment?.oreScadenzaOrdine ?? 48;

function diffOre(dataInizio, dataFine) {
  if (!dataInizio || !dataFine) return null;

  const inizio = new Date(dataInizio).getTime();
  const fine = new Date(dataFine).getTime();

  if (isNaN(inizio) || isNaN(fine)) return null;

  return (fine - inizio) / (1000 * 60 * 60);
}

function getTipoAnnullamentoOrdine(ordine) {
  if (!ordine.annullato) return null;
  const dataAnnullato = ordine.dataAnnullato;

  if (!ordine.dataDisponibilita) {
    const ore = diffOre(ordine.dataInserimento, dataAnnullato);
    if (ore !== null && ore > oreScadenzaOrdine ) {
      return 'scaduto_venditore';
    }
    return 'annullato';
  }

  const ore = diffOre(ordine.dataDisponibilita, dataAnnullato);

  if (ore !== null && ore > oreScadenzaOrdine ) {
    return 'scaduto_acquirente';
  }

  return 'annullato';
}

function getStatusBadge(ordine){
  const tipoAnnullamento = getTipoAnnullamentoOrdine(ordine);

  if (tipoAnnullamento === 'scaduto_venditore') {
    return `<span class="ord-badge annullato">⏱ Scaduto dal venditore</span>`;
  }

  if (tipoAnnullamento === 'scaduto_acquirente') {
    return `<span class="ord-badge annullato">⏱ Scaduto dall'acquirente</span>`;
  }
  switch(getOrderStatus(ordine)){
    // 'da_confermare' | 'confermato' | 'preparazione' | 'spedito' | 'consegnato'
    case 'da_confermare':
      return `<span class="ord-badge attesa" style="">⏳ In attesa</span>`
    case 'confermato':
      return `<span class="ord-badge confermato" style="">✔ Confermato</span>`
    case 'annullato':
      if (ordine?.dataAnnullatoCliente) {
        return `<span class="ord-badge annullato" style="">✕ Annullato acquirente</span>`;
      }

      return `<span class="ord-badge annullato" style="">✕ Annullato venditore</span>`;
    case 'preparazione':
      return `<span class="ord-badge evaso" style="">✓ Evaso</span>`
    case 'spedito':
      return `<span class="ord-badge evaso" style="">✓ Evaso</span>`
    case 'consegnato':
      return `<span class="ord-badge evaso" style="">✓ Evaso</span>`
  }
  return `STATO`;
}
function getTipoBadge(ordine){
  return ordine.clienteObject?.tipiObject?.some(tipo => tipo?.label?.toLowerCase().includes('b2b')) ? `<span class="ord-badge tipo-ret">Retailer</span>`:`<span class="ord-badge tipo-cons">Consumatore</span>`
}
function getPagamentoBadge(ordine){
  if(ordine.data_conferma)
    return `<span class="pagato">Pagato</span>`
  if(ordine.data_creazione)
    return `<span class="prenotato">Prenotato</span>`
  return `<span class="prenotato">N/D</span>`
}

function Ordini_Ricevuti() {
  var OBJ: OggettoConfig = {
    Id: "ordini_ricevuti",
    RestRoute: '/progetti/progetti',
    ListResponseHasData:true,
    asyncFullResponseMap: async (
      response,
      component,
      callback
    ) => {
      const filtro = component.filtro;

      if (filtro.statoFiltro === 'CR') {
        filtro.stato_prog = 'CR';
      }

      if (filtro.statoFiltro === 'EM') {
        filtro.stato_prog = 'EM';
      }

      if (
        filtro.statoFiltro === 'SP' || filtro.statoFiltro === 'AN'
      ) {
        filtro.stato_prog = 'CO';
      }

      if (!filtro.statoFiltro) {filtro.stato_prog = 'T';}

      let data = response.data;
      if (filtro.statoFiltro === 'CR') {

        data = data.filter(
          x => getOrderStatus(x) === 'da_confermare'
        );

      }
      if (filtro.statoFiltro === 'EM') {

        data = data.filter(
          x => getOrderStatus(x) === 'confermato'
        );

      }
      if (filtro.statoFiltro === 'SP') {

        data = data.filter(
          x => getOrderStatus(x) === 'spedito'
        );

      }
      if (filtro.statoFiltro === 'AN') {
        data = data.filter(x =>
          getOrderStatus(x) === 'annullato' || getTipoAnnullamentoOrdine(x) === 'scaduto_venditore' || getTipoAnnullamentoOrdine(x) === 'scaduto_acquirente'
        );
      }
      callback({
        ...response,
        data
      });

    },
    ListDefaultFilter:{
      page: 0,
      size: 50,
      stato_prog: 'T',
      stato_progObject: { id: 'T', label: 'Tutti gli stati' },
      periodo: false,
      tipo: null,
      tipoFiltro: 'T',
      tipoFiltroObject: { id: 'T', label: 'Tutti' }
    },
    noActionLabel:true,
    listTitle:'Ordini ricevuti',
    //hasHeader:true,
    Filters:[
      CampoAggiuntivo.InputField("DATA INIZIO", 'inizio','date', 'col-lg-2 ', {
        OnChangeFunc:(x)=>{ x.periodo = !!(x.inizio?.length && x.fine?.length)},
      }),
      CampoAggiuntivo.InputField("DATA FINE", 'fine','date', 'col-lg-2 ', {
        OnChangeFunc:(x)=>{ x.periodo = !!(x.inizio?.length && x.fine?.length)},
      }),
      CampoAggiuntivo.SingleDropdown(
        "TIPO",
        'tipoFiltro',
        [
          { id:'T', label:'Tutti' },
          { id:30, label:'B2B' },
          { id:31, label:'B2C' }
        ],
        'label',
        {
          OnChangeFunc: (x) => {
            x.tipo = x.tipoFiltro === 'T' ? null : x.tipoFiltro;
          }
        }
      ),
      CampoAggiuntivo.SingleDropdown(
        "STATO",
        'stato_prog',
        [
          { id:'T', label:'Tutti' },
          { id:'CR', label:'⏳ In attesa' },
          { id:'DI', label:'✔ Confermati' },
          { id:'CO', label:'🚚 Evasi' },
          { id:'G', label:'✕ Annullati' }
        ],
        'label',
        {
        OnChangeFunc:(x)=>{
          if (!x.stato_prog || x.stato_prog === "T") {
            x.stato_prog = "T";
            x.annullati = null;
            return;
          }
          if (x.stato_prog === "G") {
            x.annullati = true;
            return;
          }

          x.annullati = false;
        }
      }
      )
    ],
    PrintHeaders:[],
    Headers: [
      CampoAggiuntivo.InputField("data", 'data_creazione', 'date', 'col-12', {modificabile:false}),
      CampoAggiuntivo.TextField("N° ORDINE", 'progressivo', 'col-12', {modificabile:false}),
      //CampoAggiuntivo.Html("Articolo", (x)=>x.progetti ? x.progetti[0]?.voci?.map(voce=>voce.voce).join(', '): 'Errore, progetti non trovati'), //deciso con alma di toglierlo
      CampoAggiuntivo.Html("Stato", (x)=>getStatusBadge(x)),
      CampoAggiuntivo.Html("Tipo", (x)=>getTipoBadge(x)),
      CampoAggiuntivo.Html("Utente", (x)=>`${x?.clienteObject?.nominativo}`),
      CampoAggiuntivo.Html("Importo", (x)=> `<span class="font-weight-bold">€${parseFloat(x.valOfferta?.toString()).toDecimals(2)}</span>`),
      CampoAggiuntivo.Html("Scadenza", (x)=> { const stato = getOrderStatus(x); if (stato!== 'da_confermare' && stato !== 'confermato')  { return '';} return `<span class="font-weight-bold">${x?.scadenza} h</span>`;})
    ],
    AzioniLista: [
      {
        nome: 'Visualizza Dettaglio',
        close: false,
        icon: '',
        iconLabel: 'Visualizza dettaglio',
        class: ' btn btn-o',
        style:{
          'padding':'5px 12px',
          'font-size':'12px',
          'white-space':'nowrap',
        },
        single:true,
        labelClass: 'text-success ',
        type: 'func',
        tooltip: "",
        func:(Item:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService, component: DynamicCrudService)=>{
          const EditModal = component.modalService.open(DynamicEditComponent, {
            centered: true,
            backdrop: 'static',
            container: '#main-wrapper',
            size: 'xl'
          });
          var obj = Item ? Object.assign({}, Item ?? {}, ) : Object.assign(this.CrudSettings.AddDefaultObject ?? {});
          (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = Ordine();
          //(<DynamicEditComponent>EditModal.componentInstance).ConcatParamsEdit = this.ConcatParamsEdit;
          (<DynamicEditComponent>EditModal.componentInstance).Item = obj;
          (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
            setTimeout(() => { if(onEnd) onEnd(); }, 1000)
          });
        },
      }
    ],
    MenuItems:[
      {
        path: "",
        title: "Vendi",
        icon: "",
        class: "",
        extralink: true,
        capacita: ['is-venditore'],
        submenu: []
      },
      {
        path: 'shared/dynamiclist/ordini_ricevuti',
        title: "Ordini ricevuti",
        icon: "fas fa-cart",
        class: "",
        capacita: ['is-venditore'],
      }
    ]
  }
  return OBJ;
}

function Ordine(): OggettoConfig{
  return {
    Id: 'ordine',
    NoSave:true,
    RestRoute: '/progetti/progetti',
    Label: 'Dettagli dell\'ordine',
    GetResponseHasData:true,
    asyncMap: (
      ordine,
      component,
      callback
    )=>{
      const vociTable = [];
      ordine.progetti?.forEach(progetto=>{
        progetto.voci?.forEach(voce=>{
          vociTable.push({
            ...voce,
            tagliaLabel: voce.tagliaObject?.taglia ?? '',
            coloreLabel: voce.coloreObject?.[0]?.check ?? ''

          });
        });
      });
      ordine.vociTable = vociTable;
      callback(ordine);
    },
    campi: [
      CampoAggiuntivo.Html("", (ordine, parent)=>`
      <div id="ordDetBody" >
    <div class="ord-det-grid" >
      <div class="ord-det-left">
        <div class="ord-det-lbl">Negozio</div>
        <p class="nome-negozio">${ordine?.clienteObject?.fullName}</p>
        <p class="dettaglio-negozio">${ordine?.clienteObject?.indirizzo ?? ''}, ${ordine?.clienteObject?.citta ?? ''}, ${ordine?.clienteObject?.provincia ?? ''}, ${ordine?.clienteObject?.cap ?? ''}<br>Email: ${ordine.clienteObject.email ?? ''}<br>Telefono: ${ordine.clienteObject.telefono ?? ''}</p>
      </div>
      <div class="ord-det-right">
        <div class="ord-det-lbl">Riepilogo ordine</div>
        <div class="ord-det-info-row"><span>Ordine</span><span class="font-monospace">${ordine.progressivo}</span></div>
        <div class="ord-det-info-row"><span>Tipo</span><span>${getTipoBadge(ordine)}</span></div>
        <div class="ord-det-info-row"><span>Stato</span><span id="ordDetStatoBadge">${getStatusBadge(ordine)}</span></div>
        <div class="ord-det-info-row"><span>Pagamento</span>${getPagamentoBadge(ordine)}</div>
        <div class="ord-det-info-row"><span>Data</span><span>${dateTimeStringToFormattedDate(ordine.data_creazione)}</span></div>
      </div>
    </div>
    `, ()=>true, {class:'col-12'}),
      CampoAggiuntivo.TableField(
        "Articoli",
        [
          CampoAggiuntivo.Html(
            "",
            (x,parent)=>`
    <div class="ord-art-img">
      <img
        src="${ImageUrl(x, {...parent, api:parent.apiPaths})}"
        alt="${x.voce}"
        class="d-gal-img"
      >
    </div>
  `,
            ()=>true,
            {
              class:'col-auto',
              modificabile:false
            }
          ),

          CampoAggiuntivo.TextField(
            "Articolo",
            "voce",
            "col-12",
            {modificabile:false}
          ),

          CampoAggiuntivo.TextField(
            "Taglia",
            "tagliaLabel",
            "col-12",
            {modificabile:false}
          ),

          CampoAggiuntivo.TextField(
            "Colore",
            "coloreLabel",
            "col-12",
            {modificabile:false}
          ),

          CampoAggiuntivo.TextField(
            "Quantità Richiesta",
            "quantitaRic",
            "col-12",
            {modificabile:false}
          ),

          CampoAggiuntivo.InputField(
            "Quantità",
            "quantita",
            "number",
            "col-12",
            {
              modificabile:true,
              min:0,
              style:{
                width:'70px',
                'min-width':'70px',
                padding:'4px 6px',
                'text-align':'center'
              }
            }
          ),

          CampoAggiuntivo.Html(
            "Prezzo (€)",
            (x) => {
              const p = getVocePrezzoValues(x);

              if (!p.sconto) {
                return `€${p.prezzoInteroIvato.toDecimals(2)}`;
              }

              return `
<div class="ordine-price-box">
      <span class="ordine-old-dettaglio">€${p.prezzoInteroIvato.toDecimals(2)}</span>
      <span class="ordine-promo-badge-dettaglio">-${p.sconto}%</span>
      <span class="ordine-price-dettaglio">€${p.prezzoScontatoIvato.toDecimals(2)}</span>
      </div>
    `;
            },
            () => true,
            {
              modificabile: false
            }
          ),

          CampoAggiuntivo.Html(
            "Totale (€)",
            (x) => {
              const p = getVocePrezzoValues(x);

              if (!p.sconto) {
                return `
        <span class="font-weight-bold">
          €${p.importoIntero.toDecimals(2)}
        </span>
      `;
              }

              return `
<div class="ordine-price-box">
      <span class="font-weight-bold">
        <span class="ordine-old-dettaglio">€${p.importoIntero.toDecimals(2)}</span>
        <span class="ordine-promo-badge-dettaglio">-${p.sconto}%</span>
        <span class="ordine-price-dettaglio">€${p.importoScontato.toDecimals(2)}</span>
      </span>
      </div>
    `;
            },
            () => true,
            {
              modificabile: false
            }
          ),


        ],
        "vociTable",
        true,
        "col-12"
      )
    ],
    Azioni:[
      ActionButton.FuncButton("Annulla ordine", (x, api:ApiPathsService, onEnd)=>{
        if(!confirm("Sei sicuro di voler annullare l'ordine?"))
          return
        x = getOrdineDefaultSave(x);
        x.annullato = true;
        x.progetti.forEach(progetto => {
          progetto.annullato = true;
        })
        api.ClassicPost("/progetti/ordini/update", x).subscribe(x=>{
          api.toastService.success("Ordine annullato con successo", "Ordine annullato", {timeOut:10000, extendedTimeOut:3000, toastClass:'marketplace-success-toast'});
          if(onEnd)
            onEnd();
        })

      },{
        class: 'btn-annulla-ord',
        close: false,
        hideif:{func:(x)=>!x.annullato && !x.data_emissione}
      }),
      ActionButton.FuncButton("Conferma ordine", (x, api, onEnd) => {

        const ordineDaSalvare = JSON.parse(JSON.stringify(x));

        let index = 0;

        ordineDaSalvare.progetti?.forEach(progetto => {

          progetto.voci?.forEach(voce => {

            voce.quantita =
              x.vociTable[index]?.quantita;

            index++;

          });

        });

        const payload = getOrdineDefaultSave(ordineDaSalvare);

        payload.data_emissione = DateToString(new Date());

        api.ClassicPost("/progetti/ordini/update", payload).subscribe({
          next: (res) => {
            api.toastService.success(
              "Ordine confermato con successo",
              "Ordine confermato",
              {timeOut:10000, extendedTimeOut:3000, toastClass:'marketplace-success-toast'}
            );

            if (onEnd) {
              onEnd();
            }
          },

          error: (err) => {
            console.error("Errore conferma ordine", err);
            //const messagge = err ?? "Errore durante la conferma dell'ordine";
           // api.toastService.error(messagge, "Errore durante la conferma dell'ordine", {timeOut:15000, extendedTimeOut:5000});


          }
        });

      }, {
        class: 'btn-conferma',
        close: false,
        hideif: { func: (x) => !x.annullato && !x.data_emissione }
      })

    ]
  }
}

export function getOrdineDefaultSave(x){
  x.oggetto = x.oggetto ?? x.clienteObject?.fullName
  Object.getOwnPropertyNames(x).forEach(key => {
      if(key.endsWith('Object') && x[key] && !Array.isArray(x[key]))
        x[key.replace('Object', '')] = x[key].id;
      if(key.endsWith('Object') && x[key] && Array.isArray(x[key]))
        x[key.replace('Object', '')] = x[key].map(item => item.id);
    }
  )
  x.valOfferta = x.progetti.reduce(
    (acc, progetto) =>
      acc + progetto.voci.reduce(
        (acc2, voce) =>
          acc2 + getVocePrezzoValues(voce).importoScontato,
        0
      ),
    0
  );
  return x;
}

function getVocePrezzoValues(voce: any) {
  const iva = Number(voce.iva ?? 22);
  const quantita = Number(voce.quantita ?? voce.quantitaRic ?? 1);

  const prezzoNetto = Number(voce.prezzo ?? 0);
  const sconto = Number(voce.sconto ?? 0);

  const prezzoInteroIvato = PrezzoIvato(prezzoNetto, iva) ?? 0;

  const prezzoScontatoIvato = sconto > 0
    ? prezzoInteroIvato - ((prezzoInteroIvato / 100) * sconto)
    : prezzoInteroIvato;

  return {
    quantita,
    sconto,
    prezzoInteroIvato,
    prezzoScontatoIvato,
    importoIntero: prezzoInteroIvato * quantita,
    importoScontato: prezzoScontatoIvato * quantita
  };
}

export var Ordini_RicevutiEnv = () => {
  var env: any = {
    Modules: {
      "Ordini_Ricevuti": true
    },
    Cruds: [Ordini_Ricevuti(), Ordine()],
    Menu: [...Ordini_Ricevuti().MenuItems]
  }
  return env;

}
